/* Colour swatches on product cards: hover or focus a swatch to show that colour on the card.
   Clicking a swatch is a normal link to the product in that colour, so phones just follow the link.
   Uses event delegation, so cards loaded later (filters, sorting, pagination) work too. */
(function () {
  if (window.cardSwatchesReady) return;
  window.cardSwatchesReady = true;

  var canHover = window.matchMedia ? window.matchMedia('(hover: hover)') : { matches: true };

  function swatchFrom(el) {
    return el && el.closest ? el.closest('.card-swatch') : null;
  }
  function mainImg(card) {
    return card.querySelector('.card__media .media img');
  }

  function show(sw) {
    var card = sw.closest('.card-wrapper');
    if (!card || !sw.dataset.src) return;
    var img = mainImg(card);
    if (!img) return;
    if (img.dataset.csSrc === undefined) {
      img.dataset.csSrc = img.getAttribute('src') || '';
      img.dataset.csSrcset = img.getAttribute('srcset') || '';
    }
    img.setAttribute('srcset', sw.dataset.srcset || sw.dataset.src);
    img.setAttribute('src', sw.dataset.src);
    card.classList.add('card-swatches--active');
    card.querySelectorAll('.card-swatch.is-active').forEach(function (el) {
      el.classList.remove('is-active');
    });
    sw.classList.add('is-active');
  }

  function reset(card) {
    var img = mainImg(card);
    if (img && img.dataset.csSrc !== undefined) {
      img.setAttribute('srcset', img.dataset.csSrcset);
      img.setAttribute('src', img.dataset.csSrc);
    }
    card.classList.remove('card-swatches--active');
    card.querySelectorAll('.card-swatch.is-active').forEach(function (el) {
      el.classList.remove('is-active');
    });
  }

  document.addEventListener('mouseover', function (e) {
    if (!canHover.matches) return;
    var sw = swatchFrom(e.target);
    if (sw) show(sw);
  });
  document.addEventListener('focusin', function (e) {
    var sw = swatchFrom(e.target);
    if (sw) show(sw);
  });

  function leave(e) {
    var card = e.target.closest ? e.target.closest('.card-wrapper.card-swatches--active') : null;
    if (card && !card.contains(e.relatedTarget)) reset(card);
  }
  document.addEventListener('mouseout', leave);
  document.addEventListener('focusout', leave);
})();
